import { createSlice } from "@reduxjs/toolkit";

export const placementsSlice = createSlice({
  name: "placements",
  initialState: {
    loading: false,
    error: null,
    placements: [],
    currentPlacement: {},
  },
  reducers: {
    clearPlacementsData(state) {
      state.loading = false;
      state.error = null;
      state.placements = [];
      state.currentPlacement = {};
    },
    getAllPlacementsStart(state, action) {
      state.loading = true;
      state.placements = [];
    },
    getAllPlacementsSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.placements = action.payload;
    },
    getAllPlacementsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    /////////////////////////////////

    getPlacementByUiidStart(state, action) {
      state.loading = true;
      state.placements = [];
    },
    getPlacementByUiidSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.placements = action.payload;
    },
    gePlacementByUiidFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    /////////////////////////////////

    addNewPlacementStart(state) {
      state.loading = true;
      state.error = null;
    },

    addNewPlacementSuccess(state) {
      state.loading = false;
    },
    addNewPlacementFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    addCurrentPlacement(state, action) {
      const data = action.payload;
      if (!data || typeof data !== "object" || Object.keys(data).length === 0) {
        // If data is falsy, not an object, or an empty object
        state.currentPlacement = {};
      } else {
        state.currentPlacement = {
          ...state.currentPlacement,
          ...data,
        };
      }
    },
  },
});

export const {
  clearPlacementsData,
  getAllPlacementsStart,
  getAllPlacementsSuccess,
  getAllPlacementsFailure,
  getPlacementByUiidStart,
  getPlacementByUiidSuccess,
  gePlacementByUiidFailure,
  ///////////////
  addNewPlacementStart,
  addNewPlacementSuccess,
  addNewPlacementFailure,
  addCurrentPlacement,
} = placementsSlice.actions;

export default placementsSlice.reducer;
